<template>
  <ModalWrapper
    :style="wrapperStyle"
    :loading="loading"
  >
    <template #header-left>
      <div class="b-nav-bar__panel-btns b-nav-bar__panel-btns--left">
        <c-btn
          disable-style
          :w100="false"
          class="b-nav-bar__panel-btns-item"
          @click="goToEnterPhone"
        >
          <div class="b-nav-bar__icon">
            <sprite
              src="sprites_arrow-m-left"
              class="b-nav-bar__icon-sprite b-nav-bar__icon-sprite--stroke"
            />
          </div>
        </c-btn>
      </div>
    </template>
    <template #header-text>
      <span>Подтверждение номера</span>
    </template>
    <template #header-right>
      <div class="sign-in-modal__close-btn">
        <div class="sign-in-modal__close-icon" />
      </div>
    </template>
    <template #default>
      <div
        class="enter-sms"
        :class="{ 'enter-sms--mobile': $isSmartphone }"
      >
        <div class="enter-sms__title">
          Введите код из СМС
        </div>
        <div class="enter-sms__text">
          Код выслан на +7 {{ phone }}
        </div>
        <VueRecaptcha
          ref="recaptcha"
          size="invisible"
          :sitekey="googleApiKey"
          @verify="onCaptchaVerified"
          @expired="resetCaptcha"
        />
        <SmsCode
          ref="smsCode"
          v-model:value="code"
          class="enter-sms__sms-code"
          @focus="errorCode = false"
        />
        <transition
          name="fade"
          :duration="300"
        >
          <div
            v-if="!errorTime && errorCode"
            class="enter-sms__error"
          >
            Неверный код для входа,<br>
            проверьте его или получите новый
          </div>
        </transition>

        <transition
          name="fade"
          :duration="300"
        >
          <div
            v-if="errorTime"
            class="enter-sms__error"
          >
            Срок действия кода истек <br>
            Пожалуйста, получите новый код
          </div>
        </transition>

        <transition
          name="fade"
          :duration="300"
        >
          <div
            v-if="messageTime"
            class="enter-sms__message"
          >
            <div>Получить новый код </div>
            <div>можно через {{ timeFormat }}</div>
          </div>
          <div
            v-else
            class="enter-sms__message"
          >
            <div
              class="enter-sms__message-btn"
              :class="{'enter-sms__message-btn--disabled':resendSmsButtonDisabled}"
              @click="reSendSms"
            >
              Получить новый код
            </div>
          </div>
        </transition>
      </div>
    </template>
  </ModalWrapper>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex'
import { VueRecaptcha } from 'vue-recaptcha'
import ModalWrapper from './ModalWrapper'
import SmsCode from './SmsCode'
import api from '@/api'

const defaultTime = 90

export default {
  components: {
    ModalWrapper,
    SmsCode,
    VueRecaptcha,
  },
  props: {
    params: {
      type: Object,
      default () {
        return null
      },
    },
  },
  data () {
    return {
      code: '',
      errorCode: false,
      errorTime: false,
      messageTime: true,
      googleApiKey: process.env.VUE_APP_GOOGLE_API_KEY_TEST,
      time: window.smsTime || defaultTime,
      interval: null,
      resendSmsButtonDisabled: false,
      recaptchaToken: null,
      loading: false,
    }
  },
  computed: {
    ...mapGetters({
      allCities: 'cities/all',
      activeCity: 'cities/active',
      profile: 'client/profile',
    }),
    phone () {
      if (this.params?.phone) {
        if (this.params?.phone.slice(0, 2) === '+7') {
          return this.params?.phone.slice(2)
        } else {
          return this.params?.phone
        }
      }
      return ''
    },
    timeFormat () {
      const sec = this.time % 60
      return `0${(Math.trunc(this.time / 60))}:${sec < 10 ? '0' + sec : sec}`
    },
    wrapperStyle () {
      return {}
    },
  },
  watch: {
    code (val) {
      if (val.length === 4) {
        this.sendSmsCode()
      }
    },
  },
  mounted () {
    if (window.smsIntervalTimerEnd) {
      this.errorTime = true
      this.messageTime = false
    } else {
      this.errorTime = false
      this.messageTime = true
      this.initInterval()
    }
    this.$refs.smsCode.focus()
  },
  methods: {
    ...mapMutations({
      openModal: 'modals/openModal',
      closeModal: 'modals/closeModal',
    }),
    ...mapActions({
      // sendSms: 'client/authSendSms',
      sendSms: 'client/sendSms',
      loginByCode: 'client/loginByCode',
      checkSms: 'client/checkSms',
      confirmActiveWithMenu: 'cities/confirmActiveWithMenu',
      setOtherCityMode: 'cities/setOtherCityMode',
    }),
    onCaptchaVerified (response) {
      this.recaptchaToken = response
      this.sendP()
      this.resetCaptcha()
    },
    resetCaptcha () {
      this.$refs.recaptcha.reset()
      this.recaptchaToken = null
    },
    goToEnterPhone () {
      window.smsIntervalTimerEnd = false
      this.errorTime = false
      this.messageTime = false

      const configModal = {
        name: 'EnterPhone',
        params: {
          phone: this.params?.phone,
          openCheckoutForm: this.params?.openCheckoutForm,
          afterLogIn: this.params?.afterLogIn,
        },
      }
      this.openModal(configModal)
      setTimeout(() => {
        this.closeModal('EnterSms')
      }, 400)
    },
    reSendSms () {
      if (!this.resendSmsButtonDisabled) {
        this.code = ''
        if (this.isCaptchaEnabled) {
          this.initCaptchaListener()
          this.$refs.recaptcha.execute()
        } else {
          this.sendP()
        }
      }
    },
    sendP () {
      // send phone
      this.loading = true
      this.code = ''
      this.resendSmsButtonDisabled = true

      const clientData = { phone: this.phone }
      if (this.recaptchaToken) {
        clientData.recaptchaToken = this.recaptchaToken
      }

      this.sendSms(clientData)
        .then(() => {
          this.code = ''
          this.errorCode = false
          this.initInterval()
          // this.openModal({name: 'EnterSms', params: {phone: this.phone}})
        })
        .catch((error) => {
          const errorMessage = error?.response?.data?.messages[0]
          if (errorMessage === 'enable_captcha') {
            this.$refs.recaptcha.execute()
            return
          }

          console.log('error', error)
          this.errorCode = true
        })
        .finally(() => {
          this.loading = false
          this.resendSmsButtonDisabled = false
          this.errorTime = false
        })
    },

    async sendSmsCode () {
      this.loading = true
      if (this.$isSmartphone) {
        this.$store.dispatch('analytics/singleEvent', 'mob_order_check_sms', { root: true })
      } else {
        this.$store.dispatch('analytics/singleEvent', 'order_check_sms', { root: true })
      }
      try {
        await this.checkSms({
          phone: this.phone,
          code: this.code,
        })

        clearInterval(window.smsIntervalTimer)
        this.setDefaultIntervalParams()

        if (this.params.afterLogIn) {
          await this.params.afterLogIn(() => {
            this.closeModal('EnterPhone')
            this.closeModal('EnterSms')
            this.loading = false
          })
        } else {
          // DEV-12266 у отвала свой cjm
          // отвал это activityStatus == 'old'
          if (this.profile?.activityStatus === 'old') {
            api.redirectToOldSite({
              paths: '/dashboard/orders',
            })
          }
          this.closeModal('EnterPhone')
          this.closeModal('EnterSms')
          this.loading = false
        }
      } catch (error) {
        this.errorCode = true
        this.loading = false
        if (this.$isSmartphone) {
          this.$store.dispatch('analytics/singleEvent', 'mob_order_check_sms_error', { root: true })
        } else {
          this.$store.dispatch('analytics/singleEvent', 'order_check_sms_error', { root: true })
        }
      }

      this.$gtm.trackEvent({
        event: 'registration_or_login',
      })
    },
    intervalFunc () {
      window.smsTime--
      this.time = window.smsTime
      if (window.smsTime < 0) {
        this.errorTime = true
        this.messageTime = false
        clearInterval(window.smsIntervalTimer)
        window.smsIntervalTimer = null
        window.smsIntervalTimerEnd = true
      }
    },
    setDefaultIntervalParams () {
      window.smsTime = defaultTime
      this.time = window.smsTime
      this.errorTime = false
      this.messageTime = true
    },
    initInterval () {
      window.smsIntervalTimerEnd = false
      if (window.smsIntervalTimer) {
        clearInterval(window.smsIntervalTimer)
        window.smsIntervalTimer = setInterval(this.intervalFunc, 1000)
      } else {
        this.setDefaultIntervalParams()
        window.smsIntervalTimer = setInterval(this.intervalFunc, 1000)
      }
    },
  },
}
</script>

<style lang="scss">
.sms-code {

}
.enter-sms {
  position: relative;
  // height: 100%;
  width: calc(100% - 0.24rem);
  margin: 0 auto;
  padding: 0.32rem 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  overflow: hidden;
  &__title {
    font-weight: normal;
    // margin-top: (60 * 100% / 459 );
    font-size: 20px;
    line-height: 24px;
  }
  &__text {
    margin-top: (4 * 100% / 459 );
    font-weight: 300;
    font-size: .14rem;
    line-height: .22rem;
  }
  &__sms-code {
    margin: (24 * 100% / 459 ) auto .36rem;
  }
  &__message {
    margin: 0.24rem auto 0;
    font-weight: 300;
    font-size: .14rem;
    line-height: .20rem;
  }
  &__message-btn {
    color: map-get($colors, 'default');
    font-weight: 600;
    cursor: pointer;
    &--disabled {
      opacity: 0.7;
    }
  }
  &__error {
    margin: (24 * 100% / 459 );
    color: map-get($colors, 'red_error');
    font-size: .12rem;
    line-height: .14rem;
    text-align: center;
    letter-spacing: .00497696rem;
  }
  &--mobile {
    .enter-sms {
      &__message {
        margin: (136 * 100% / 459) 0 (8 * 100% / 459 );
      }
    }
  }
}
</style>
